<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo, sort} from "../lib/lib";
    import Modal from "../components/modal/Modal.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import CheckboxIcon from "../components/icons/CheckboxIcon.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";


    export let selected = [];
    export let callbackHandler;

    const tableColumns = [
        {key: 'selected', title: 'checkbox', sortable: true, sort_way: 'ASC'},
        {key: 'name', title: 'NAME', sortable: true},
    ];

    let list = null;
    let name = '';

    const load = () => {
        const onSuccess = result => {
            list = result;
            list.map(item => {
                item.selected = selected.indexOf(item.id) > -1;
            });
            list = sort(list, 'selected', true);
        }

        const onFailure = err => {
        };

        R.handle(R.user.index, {name}, onSuccess, onFailure, LOADER.POPUP);
    }

    const onKeyUp = (event) => {
        if (event.key === 'Enter') {
            name = event.target.value;
            load();
        }
    }

    const onColumnSort = ({detail: column}) => {
        name = sort(name, column.key, column.sort_way === 'ASC');
    }

    const onClick = (item) => {
        item.selected = !item.selected;
        if (item.selected) {
            selected = [...selected, item.id];
        } else {
            selected = selected.filter(x => x != item.id);
        }
        list = list;
    }

    const selectAll = () => {
        selected = [];
        list.map(item => {
            item.selected = true;
            selected = [...selected, item.id];
        });
        list = list;
    }

    const selectNone = () => {
        selected = [];
        list.map(item => {
            item.selected = false;
        });
        list = list;
    }

    const applySelection = () => {
        callbackHandler(selected);
    }

    const close = () => {
        callbackHandler();
    }

    setFocusTo("searchName");
    load();
</script>

{#if list}
    <Modal title="Select Users" on:close="{ close }">
        <div slot="body">
            <div class="tools-box mb-3">
                <div class="input-group me-1">
                    <input type="text" class="form-control" id="searchName" bind:value="{ name }" on:keyup="{ onKeyUp }"
                           placeholder="find department">
                    <button class="btn btn-default" on:click={ load }>
                        <AppIcon icon="search" size="16"/>
                    </button>
                </div>
                <button class="btn btn-default btn-flex line-height-1" title="select all" on:click="{ selectAll }">
                    <CheckboxIcon checked/>
                </button>
                <button class="btn btn-default btn-flex line-height-1" title="select none" on:click="{ selectNone }">
                    <CheckboxIcon/>
                </button>
            </div>
            <table class="table table-list table-list-border">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#each list as item}
                    <tr class="row-hover pointer" on:click="{ () => onClick(item) }">
                        <td class="checkbox-column">
                            {#if item.selected}
                                <CheckboxIcon size="medium" absolute checked/>
                            {/if}
                        </td>
                        <td class:not-active="{ item.is_active < 1}">
                            { item.name }
                            <div class="small">
                                { item.email }
                            </div>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
            {#if selected.length}
                <div class="mt-1">
                    { selected.length } users selected
                </div>
            {/if}
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ applySelection }">OK</button>
            </div>
        </div>
    </Modal>
{/if}